/**
 * useEditorCanvas — JointJS graph/paper setup plus zoom controls.
 * Composes useJointJSCanvas + useCanvasZoom (panning stays separate until blank-click handler exists).
 */

import { RefObject } from 'react'
import { useJointJSCanvas } from './useJointJSCanvas'
import { useCanvasZoom } from './useCanvasZoom'
import { useCanvasEditorOverlay, CanvasRelationEdit } from './useCanvasEditorOverlay'
import { ObjectType } from '../../../map-editor-shared/store/objectTypeStore'
import type { TemplateRelationType } from '../../../map-editor-entities/schema/templateSchema'

export function useEditorCanvas(
  canvasRef: RefObject<HTMLDivElement | null>,
  onZoomChange?: (zoom: number) => void,
  canvasId?: string,
  currentTool?: string | null,
  selectedType?: ObjectType | null,
  onObjectCreated?: () => void,
  relationTypes?: Record<string, TemplateRelationType>,
  relationEdit?: CanvasRelationEdit
) {
  const { graph, paper } = useJointJSCanvas(canvasRef, canvasId)
  // Phase 1/2/3 (flag CANVAS_EDITOR): no-op when off; Canvas overlay when on.
  useCanvasEditorOverlay(canvasRef, graph, paper, currentTool, selectedType, onObjectCreated, relationTypes, relationEdit)
  const { handleZoomIn, handleZoomOut, handleZoomReset, handleFitToScreen } = useCanvasZoom(
    paper,
    canvasRef,
    onZoomChange
  )
  return {
    graph,
    paper,
    handleZoomIn,
    handleZoomOut,
    handleZoomReset,
    handleFitToScreen,
  }
}
